/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

import { AuthenticationService } from './authentication.service';
import { BaseService } from "./base-service";

import { Event } from '../models/event';
import { EventInstance } from '../models/event-instance';
import { RestService } from './rest-service';
import { Url_Base } from 'app/rest-constants';

@Injectable()
export class EventService extends BaseService {

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private restService: RestService) {
        super(router, authenticationService);
    }

    private getUrl(): string {
        return `${Url_Base}/events/`;
    }

    getEventById(id: number): Promise<Event> {
        const url = this.getUrl() + `${id}`;
        
        return this.restService.get<Event>(url);
    }

    getAllEvents(): Promise<Event[]> {
        const url = this.getUrl();
        
        return this.restService.get<Event[]>(url);
    }
    
    createEvent(event: Event): Promise<Event> {
        const url = this.getUrl();
        
        return this.restService.post<Event>(url, event);
    }

    generateEvent(event: EventInstance): Promise<void> {
        const url = this.getUrl() + 'instances/generate';
        
        return this.restService.post(url, event);
    }
    
    updateEvent(event: Event): Promise<Event> {
        const url = this.getUrl();

        return this.restService.put<Event>(url, event);
    }

    deleteEvent(id: number): Promise<any> {
        const url = this.getUrl() + `${id}`;
 
        return this.restService.delete(url);
    }

    deleteEvents(ids: number[]): Promise<any> {
        const callUrl = this.getUrl();
        return this.restService.delete(callUrl, ids);
    }
    
}
